export const handicapList = [
  '平手', '平/半', '半球', '半/一', '一球', '一/半', '球半', '球半/二', '二球', '二/半', '二半', '二半/三', '三球', '三/半', '三半', '三半/四', '四球', '四/半', '四半', '四半/五', '五球', '五/五半', '五半', '五半/六', '六球', '六/六半', '六半', '六半/七', '七球', '七/七半', '七半', '七半/八', '八球', '八/八半', '八半', '八半/九', '九球', '九/九半', '九半', '九半/十', '十球', '十/十半', '十半', '十半/十一', '十一球', '十一/十一半', '十一半', '十一半/十二球', '十二球', '十二/十二半', '十二半', '十二半/十三球', '十三球', '十三/十三半', '十三半', '十三半/十四球', '十四球', '十四/十四半', '十四半', '十四半/十五球', '十五球', '十五/十五半', '十五半', '十五半/十六球', '十六球', '十六/十六半', '十六半', '十六半/十七球', '十七球', '十七/十七半', '十七半', '十七半/十八球', '十八球', '十八/十八半', '十八半', '十八半/十九球', '十九球', '十九/十九半', '十九半', '十九半/二十球', '二十球'
]
export const common = {
  previousStep: '上一轮',
  nextStep: '下一轮',
  close: '关闭',
  notFoundText: '抱歉，您找的页面不存在',
  euro: '欧元',
  dollar: '美元',
  pound: '英镑',
  rmb: '人民币',
  cancel: '取消',
  mounth: '月份'
}
export const noticeView = {
  loading: '加载中...',
  netError: '网络错误',
  noData: '没有数据',
  refreshBtnTitle: '点击刷新'
}
export const integral = {
  rank: '排名',
  teamName: '球队',
  scene: '场次',
  result: '胜/平/负',
  gainAndLoss: '得/失',
  integral: '积分',
  leagueFormat: '赛制说明'
}
export const btnList = {
  schedule: '赛程',
  integral: '积分表',
  playerList: '球员榜',
  oddsStatistics: '盘路统计'
}
export const integralBtnList = {
  totalIntegral: '总积分',
  homeIntegral: '主场积分',
  guestIntegral: '客场积分'
}
export const players = {
  shooters: '射手榜',
  own: '乌龙',
  yellowCard: '黄牌',
  redCard: '红牌',
  showAll: '查看全部',
  rank: '排名',
  player: '球员',
  teamName: '球队',
  total: '总计'
}
export const oddsStatistics = {
  totalCourt: '总场数',
  homeCourt: '主场',
  guestCourt: '客场',
  matchCount: '赛',
  hasOdds: '开',
  han: '上',
  winAndLoss: '赢/走/输',
  goalDifference: '净胜',
  winningRate: '赢盘率',
  dataStatistics: '盘路数据统计',
  winMost: '赢盘之最',
  homeWin: '主场赢盘',
  draw: '和局走水',
  guestWin: '客场赢盘',
  site: '场',
  btnWin: '赢盘',
  btnDraw: '走水',
  winRate: '赢盘率'
}
export const scheduleNotesTitle = {
  halfCourt: '半场',
  fullHalf: '全/半',
  singleAndDouble: '单双',
  letBall: '让球',
  runTitle: '第',
  runTitle1: '轮'
}
export const playerInfo = {
  playingTeam: '效力球队',
  playerHonor: '球员荣誉',
  playerProfile: '球员简介',
  currentTeam: '所属球队',
  joinTime: '加盟时间',
  salary: '薪金',
  formerTeam: '前效力球队',
  previousTeam: '曾效力球队',
  transferFee: '转会费'
}
export const playerIndex = {
  height: '身高',
  bodyWeight: '体重',
  worth: '身价',
  playerInfo: '球员信息',
  playerStats: '数据统计',
  playerPosition: '位置',
  jerseyNumber: '俱乐部球衣号',
  numberName: '号',
  ouYuan: '欧元',
  meiYuan: '美元',
  yingBang: '英镑',
  renMinBi: '人民币',
  wan: '万'
}
export const teamIndex = {
  founded: '成立',
  officialWebsite: '官网',
  fixture: '赛程',
  trackRecord: '往绩',
  stats: '数据',
  lineUp: '阵容',
  playerList: '球员榜',
  info: '资料',
  transfer: '转会',
  totalPrice: '总身价',
  record: '近期战绩',
  win: '胜',
  draw: '平',
  loss: '负'
}
export const dataStatistics = {
  twoYearData: '近2年比赛数据',
  jinQiu: '进球',
  dianQiu: '点球',
  wuLong: '乌龙',
  huangPai: '黄牌',
  hongPai: '红牌',
  duiZhen: '对阵'
}
export const teamTrackRecord = {
  confrontationRecordTitle: '近20场交锋',
  latelyHandicap: '近20场开盘',
  win: '胜',
  win1: '赢',
  draw: '平',
  draw1: '走',
  lose: '负',
  lose1: '输',
  winRatio: '胜率',
  payoutWinRatio: '赢率',
  overRatio: '大分率',
  singleDigitRatio: '单率',
  sectionTitle: '近20场',
  home: '主',
  away: '客',
  neutralCourt: '中',
  homeWin: '主胜',
  homeDraw: '主平',
  homeLose: '主负',
  game: '场',
  over: '大',
  halfOver: '半场大',
  under: '小',
  halfUnder: '半场小',
  single: '单',
  double: '双',
  by: '受'
}
export const teamTransfer = {
  zhuanRu: '转入',
  zhuanChu: '转出'
}
export const stats = {
  total: '总',
  home: '主',
  neutralCourt: '中',
  away: '客',
  goalDifferenceTitle: '净胜球统计（场数）',
  goalDifference: '净胜',
  draw: '平',
  netNegative: '净负',
  goalTitle: '进球数统计（场数）',
  goalCount: '进球数',
  handicapTitle: '上下盘统计',
  homeHandicap: '上盘',
  drawHandicap: '平盘',
  guestHandicap: '下盘',
  win1: '赢',
  draw1: '走',
  lose1: '输',
  goalStatsTitle: '入球数统计（场数）',
  ball: '球',
  single: '单数',
  double: '双数'
}
export const lineUp = {
  coach: '教练',
  forward: '前锋',
  centerForward: '中场',
  guard: '后卫',
  goalkeeper: '守门员',
  numberTitle: '号'
}
export const coach = {
  sg_tz: '身高/体重',
  renJiaoQiuHui: '任教球队',
  xianShuQiuDui: '现属球队',
  qianDuQiuDui: '前度球队',
  cengXiaoLiQiuDui: '曾效力球队',
  qiuYuanRongYu: '球员荣誉',
  jieShao: '简介',
  shengRi: '生日',
  guoJi: '国籍'
}
export const teamInfo = {
  basicInfo: '基本信息',
  city: '所在城市',
  homeCourt: '球场',
  capacity: '球场容量',
  address: '联系地址',
  honour: '球队荣誉',
  summary: '球队简介'
}
